/**
 * User group ids the selected IAM roles grant access to.
 *
 * `undefined` means "no role scope"; an empty array means "the roles match no user group".
 * The empty array must never be sent as a filter value -- the backend drops an empty
 * list and the query widens back to every user -- so callers skip the request instead.
 */
export function resolveImpersonationRoleUserGroupIds({
  selectedRoleIds,
  policies
}: {
  selectedRoleIds: string[];
  policies: Array<{ principalId: string | number }> | undefined;
}): number[] | undefined {
  if (selectedRoleIds.length === 0 || policies == null) {
    return undefined;
  }

  return [...new Set(policies.map((policy) => parseInt(String(policy.principalId))).filter((id) => !isNaN(id)))];
}
